import Skeleton from 'react-loading-skeleton';

export const CartPriceLoader = () => {
  return <Skeleton />;
};
